import React from 'react';
import Button from '../atoms/Button';

const ServiceCard = ({
    image,
    duration,
    title,
    price,
    description,
    tier = 1, // 1, 2, or 3
    tag,
    onSelect
}) => {
    const isTier2 = tier === 2;

    return (
        <div className={`bg-white rounded-2xl overflow-hidden card-shadow group relative ${isTier2 ? '' : ''}`}>
            {isTier2 && (
                <div className="absolute top-0 w-full h-1 bg-gradient-to-r from-purple-400 to-pink-400 z-10"></div>
            )}

            <div className="h-64 overflow-hidden relative">
                <img
                    src={image}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    alt={title}
                />
                {tag ? (
                    <div className="absolute top-4 left-4 bg-purple-100 text-purple-900 px-3 py-1 text-[10px] font-bold uppercase tracking-widest rounded-md">
                        {tag}
                    </div>
                ) : (
                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 text-[10px] font-bold uppercase tracking-widest rounded-md">
                        {duration}
                    </div>
                )}
            </div>

            <div className="p-8">
                <div className="flex justify-between items-center mb-2">
                    <h3 className="serif text-2xl font-bold">{title}</h3>
                    <span className="text-lg font-semibold">{price}</span>
                </div>
                <p className="text-gray-500 text-sm mb-6 leading-relaxed">{description}</p>
                <Button
                    variant={isTier2 ? 'primary' : 'outline'}
                    className="w-full py-3 rounded-lg text-xs"
                    onClick={onSelect}
                >
                    Select Tier
                </Button>
            </div>
        </div>
    );
};

export default ServiceCard;
